export default {"src":"/_next/static/media/logo.5e03fe79.svg","height":109,"width":102,"blurWidth":0,"blurHeight":0};